import { HubApiRequestError } from '../api/HubApiRequestError';
import { ClusterConfig } from '../types/server';
import { getHubApi } from '../general/modules/accountServiceApi/getAccountServiceApi';

type GetMaintenanceDataResponse = {
    cluster: ClusterConfig
    maintenanceData: {
        isOn: boolean,
        startTime: number
    },
    staticBaseUrl: string
    compensationStaticUrl: string
};

export class MaintenanceMode {
    public static async getStateData(): Promise<GetMaintenanceDataResponse> {
        try {
            const hubApi = getHubApi();
            return await hubApi.getMaintenanceData(window.app.deviceIdentifier) as GetMaintenanceDataResponse;
        } catch (error) {
            throw new HubApiRequestError(error.message);
        }
    }
}
